import axios from 'axios';
import { elasticRequest } from '../../services/elasticService';

export const logTypeExists = (
  url: string,
  logIndex: string
): Promise<boolean> => {
  return new Promise((resolve) => {
    try {
      url = url + 'logtype/_search';
      const params: any = {};
      const query = {
        query: {
          match: {
            value: logIndex,
          },
        },
      };
      elasticRequest(url, JSON.stringify(query))
        .then((result: any) => {
          let justData = [];
          Object.keys(result.hits.hits).forEach((i) => {
            let data = result.hits.hits[i]._source;
            data.id = result.hits.hits[i]._id;
            justData.push(data);
          });
          if (justData.length > 0) {
            resolve(true);
          } else {
            resolve(false);
          }
        })
        .catch(function (error) {
          // handle error
          resolve(false);
          console.log(error);
        });
    } catch (ex) {
      resolve(false);
      console.log(ex);
    }
  });
};
